import BaseComponent from '../App/base';
import getAnimationData from './animation';
import * as actions from '../../actions/TrashActions';
import './index.scss';

export default class Trash extends BaseComponent {
  constructor(selector, store) {
    super(selector, store, 'trash');
    this.trashAnimationData = getAnimationData();
    this.trashAnimation = {};
    this.over = false;
    this.iconLeft = 0;

    /* Temporary fallback - for the usage with ongoing app refactoring */
    window.trashActions = actions;

    this.trashAnimationData = getAnimationData();
    this.trashAnimation = {};
    this.$icon = $('#trash-icon');

    this.init({
      container: document.getElementById('trash-icon'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
    });
    this.placeIcon();
  }

  placeIcon() {
    const leftPadding = parseInt($('#container').css('padding-left'), 10);
    const rightPadding = parseInt($('#container').css('padding-right'), 10);
    const dayHeaderLeft = 150;
    const dayHeaderRight = 130;
    const columnWidth = $('#container .column.day-column').outerWidth(true);
    const columnCount = Math.floor(($(window).width() - leftPadding - rightPadding) / columnWidth);
    const allColumnsWidth = (columnWidth * columnCount - (dayHeaderLeft + dayHeaderRight));
    const iconWidth = this.$icon.outerWidth(true);

    const trashLeft = Math.floor(allColumnsWidth / 2 - iconWidth / 2 + dayHeaderLeft);

    this.iconLeft = trashLeft

    this.dispatch(actions.place(trashLeft));
  }

  init(params) {
    const updatedParams = params;
    updatedParams.animationData = this.trashAnimationData;
    this.trashAnimation = lottie.loadAnimation(updatedParams);
    this.trashAnimation.setSpeed(4);

    const self = this;

    $('#trash').droppable({
      tolerance: 'pointer',
      drop(event, ui) {
        $('#trash').addClass('no-grab');
        const item = $(ui.draggable).clone();

        item
          .attr('id', 'delete-tmp')
          .removeClass('ui-sortable-handle')
          .addClass('for-removing')
          .addClass('into-the-void')
          .css({ top: `${ui.position.top - $(window).scrollTop()}px`, left: `${ui.position.left - 78}px` })
          .appendTo('#top-dock')
          .show();

        item.show();

        item.animate({ left: `${Math.round(self.iconLeft - 78)}px`, top: `${35 - Math.round(item.height() / 2)}px` }, 220);
        tasks.delete($(ui.draggable));
        updateCache($($('.column')[sourceContainer]).attr('rel'));

        setSpacerHeight();
        placeDone();

        sortableCancel = false;
        sortableDelete = true;

        setTimeout(() => {
          $('#delete-tmp').remove();
        }, 300);
        setTimeout(()=>{
          $('#trash').removeClass('no-grab');
        }, 500);
      },

      over() {
        self.over = true;
        self.trashAnimation.setDirection(1);
        self.trashAnimation.play();

        $('#trash-icon').hide().show(0);
        $('li.ui-sortable-helper').addClass('no-transition').addClass('for-removing');
        $('li.placeholder').hide();
      },

      out() {
        self.over = false;
        self.trashAnimation.setDirection(-1);
        self.trashAnimation.play();

        setTimeout(() => {
          $('#trash-icon').removeClass('unhover');
        }, 400);

        $('li.ui-sortable-helper').removeClass('for-removing');

        setTimeout(() => {
          $('li.ui-sortable-helper').removeClass('no-transition');
        }, 100);
        setTimeout(() => {
          $('li.placeholder').show();
        }, 50);

      },
    });
  }

  render() {
    this.$icon.css('left', `${this.state.trash.left}px`);
    if (this.state.trash.show) {
      this.trashAnimation.goToAndStop(0);
      $('#trash').fadeIn(100);
    } else $('#trash').fadeOut(100);

  }
}
